const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	listaGrupo: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'META_VISITA_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'META_VISITA_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};

        case 'META_VISITA_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};

		case 'META_VISITA_GRUPO_SELECT_LISTADO':
            return {
				...state,
				listaGrupo: action.payload.data
			};

        default:
            return state;
    }
}
